<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <v-row v-show="!loading">
    <v-col cols="8">
      <!-- Options to resize iframe -->
      <div class="d-flex justify-end">
        <v-tooltip v-if="showPreviewEmailByProductPackage" top>
          <template #activator="{ on, attrs }">
            <v-btn id="preview-package-email" v-bind="attrs" class="my-0 ml-0 mr-6" icon v-on="on" @click="switchEmailPreview">
              <v-icon color="greytxt">{{ previewEmailByProduct ? "mdi-clipboard-off-outline" : "mdi-clipboard-outline" }}</v-icon>
            </v-btn>
          </template>
          <span>{{ previewEmailByProduct ? "Désactiver le produit de cartographie" : "Aperçu du produit de cartographie des e-mails" }}</span>
        </v-tooltip>

        <v-btn-toggle
          v-model="iframeMode"
          mandatory
          background-color="#343434"
          :rounded="false"
          dense
        >
          <v-btn id="iframeModes-phone" class="iframeModes mt-1 mb-1" value="phone" @click="changeIframeMode('phone')">
            <v-icon>phone_iphone</v-icon>
          </v-btn>

          <v-btn id="iframeModes-tablet" class="iframeModes mt-1 mb-1" value="tablet" @click="changeIframeMode('tablet')">
            <v-icon>tablet</v-icon>
          </v-btn>

          <v-btn id="iframeModes-laptop" class="iframeModes mt-1 mb-1" value="laptop" @click="changeIframeMode('laptop')">
            <v-icon>laptop</v-icon>
          </v-btn>
        </v-btn-toggle>
      </div>
      <div style="background-color: rgba(0,0,0,0.3); line-height: 0px;">
        <!--- <div v-show="transparentIframeBugFix" ref="transparentIFrame" class="transparentIFrame"></div> -->
        <iframe :id="'resp-iframe'" class="resp-iframe" :src="previewUrl" title="iframe example 1" @load="iframeLoaded"></iframe>
      </div>
    </v-col>

    <v-col cols="4">
      <v-alert
        v-if="mutationSuccessMessage"
        type="success"
        transition="scale-transition"
        class="pa-3"
      >
        {{ mutationSuccessMessage }}
      </v-alert>
      <v-progress-linear v-if="selectedModule.loading" height="6" color="grey" :indeterminate="true" />
      <v-card v-if="selectedModule.active" color="secondary" class="border-radius-0">
        <v-row class="mx-0 grey darken-3">
          <v-card-title>
            <h2>{{ selectedModule.moduleName }}</h2>
          </v-card-title>
        </v-row>
        <GenerateForm
          class="side-form"
          :raw-content-types="pageBuilderRawContentTypes"
          :content.sync="moduleContent"
          :content-type="moduleContentType"
        />
      </v-card>
    </v-col>

    <SpeedboatEmailModal
      v-if="showPreviewEmailByProductPackage"
      ref="previewEmailModal"
      :preview-email-by-product-active.sync="previewEmailByProduct"
      @apply-package="sendInformation"
    />
  </v-row>
</template>
<script setup>

import gql from 'graphql-tag';

import { ref, computed, watch, toRef, onUnmounted, nextTick } from 'vue';

import { useStore } from 'vue2-helpers/vuex';
import { useQuery, useApolloClient } from '@vue/apollo-composable';
import { difference, getContentTypeByConfigArg } from '@/utils/content';
import { filterFields } from '@/utils/editor';

import { changeIframeMode } from '@/utils/cms';

import SpeedboatEmailModal from '@/components/editor/Customs/SpeedboatEmailModal.vue';

const { resolveClient } = useApolloClient();

const store = useStore();

// eslint-disable-next-line no-undef
const props = defineProps({
  builderType: {
    type: String,
    default: 'pageBuilder'
  },
  sendInformationFlag: {
    type: String,
    default: 'updatePageConfig'
  },
  receiveInformationFlag: {
    type: String,
    default: 'savePageBuilderConfig'
  },
  contentField: {
    type: String,
    default: 'page_config'
  },
  content: Object,
  previewUrl: String,
  loading: Boolean,
  mutationSuccessMessage: String,
  systemInformation: Object
});

const iframeMode = ref('laptop');

const sendInformation = info => {
  info[props.builderType] = true;
  document.getElementById('resp-iframe').contentWindow.postMessage(info, '*');
  console.log('Send information', info);
};

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:loading', 'update:content', 'update:systemInformation']);
const selectedModule = ref({
  active: false,
  moduleName: null,
  sectionID: null,
  loading: false
});

const moduleContentType = ref({});

const moduleContent = ref({});

const pageBuilderRawContentTypes = computed(() => {
  const dataTypes = { ...props.systemInformation.dataTypes };
  Object.keys(dataTypes).forEach(key => {
    dataTypes[key].configs = { type: key };
  });

  return dataTypes;
});

const prepareObject = (value, multivalued) => {
  if (multivalued) { //  [{ uuid: "XXX", ... }] to ["XXX"]
    if (value && value.length) {
      return value.filter(v => v !== null).map(v => {
        relationContents.value.push(v);
        return v.uuid;
      });
    }
    return [];
  }

  // { uuid: "XXX", ... } to "XXX"
  if (value) {
    relationContents.value.push(value);
    return value.uuid;
  }
  return null;
};

const generateEntityItemsIDs = (entityItems, fieldConfig) => {
  const dataTypeConfig = getContentTypeByConfigArg('type', fieldConfig.type, pageBuilderRawContentTypes.value);
  console.log(dataTypeConfig, fieldConfig.type, pageBuilderRawContentTypes.value);
  entityItems.forEach((value, index) => {
    if (!value.id) {
      value.id = Date.now() + index;
    }

    Object.keys(dataTypeConfig.fields).forEach(fieldKey => {
      const fieldConfigEntity = dataTypeConfig.fields[fieldKey];

      if (value[fieldKey] && fieldConfigEntity.viewType === 'Entity' && fieldConfigEntity.multivalued) {
        value[fieldKey] = generateEntityItemsIDs(value[fieldKey], fieldConfigEntity);
      }
    });
  });

  return entityItems;
};
const sendModuleData = fields => {
  const newProps = {};

  fields.forEach(fieldKey => {
    const fieldConfig = moduleContentType.value.fields[fieldKey];
    // console.log(fieldKey, fieldConfig, moduleContent.value[fieldKey]);

    if (!fieldConfig) {
      return;
    }

    if (selectedModule.value.moduleName === 'Header' && fieldKey === 'navBarItems') {
      moduleContent.value.navBarItems.forEach((navBarItem, index) => {
        // console.log('NavbarItem', navBarItem, navBarItem.label, moduleContent.value.navBarItems[index].id);

        if (!moduleContent.value.navBarItems[index].id) {
          console.log('SET ID', navBarItem.label);
          moduleContent.value.navBarItems[index].id = Math.floor(Math.random() * Date.now());
        }
      });
    }

    if (fieldConfig.viewType === 'Picker') {
      newProps[fieldKey] = prepareObject(moduleContent.value[fieldKey], fieldConfig.multivalued);
    } else if (fieldConfig.viewType === 'Entity' && fieldConfig.multivalued) {
      newProps[fieldKey] = generateEntityItemsIDs(moduleContent.value[fieldKey], fieldConfig);
    } else {
      newProps[fieldKey] = moduleContent.value[fieldKey];
    }
  });

  //  if (newContent !== null && this.selectedModule.active) {

  //           const fieldConfig = this.pageBuilderContentType.fields[updatedFieldKey];

  //           newProps[updatedFieldKey] = this.pageBuilderContent[updatedFieldKey];

  //           if (fieldConfig.viewType === 'Entity' && fieldConfig.multivalued) {
  //             newProps[updatedFieldKey] = this.generateEntityItemsIDs(this.pageBuilderContent[updatedFieldKey], fieldConfig);
  //           }
  //         });

  console.log('SEND MODULE DATA', newProps);

  sendInformation({ updateModule: true, selectedModule: selectedModule.value, props: newProps });
};

const clonedContent = computed(() => JSON.parse(JSON.stringify(moduleContent.value)));

watch(
  clonedContent,
  async (newVal, oldVal) => {
    sendInformation({ loading: true });
    const fieldsToBeSent = Object.keys(difference(newVal, oldVal));
    sendModuleData(fieldsToBeSent);
    store.commit('setHasChanges', true);
  },
  { deep: true }
);

const iframeLoaded = async () => {
  // alert('test');
  // ON Alpha we need to send references
  sendInformation({ references: store.state.references || {} });

  if (props.content[props.contentField]) {
    const infomation = { [props.sendInformationFlag]: JSON.parse(props.content[props.contentField]) };

    sendInformation(infomation);
  }

  emit('update:loading', false);
};

const relationContents = ref([]);

const findContentByUuid = uuid => relationContents.value.find(p => p.uuid === uuid) || null;

const cancelToken = {};

const receiveModuleData = async (data, moduleFields, moduleName, sectionID, token) => {
  let cancelled = false;

  selectedModule.value.active = false;

  console.log('[PIM] - Page builder received fields', moduleContentType.value);

  token.cancel = () => {
    cancelled = true;
  };

  // GET INFORMATION WITH THE PICKER UUIDS (ex: ["uuid1", "uuid2"] ---> [{ uuid: "uuid1", ... }, { uuid: "uuid2", ...}])
  let pickerRelations = [];
  Object.entries(moduleFields).forEach(([fieldName, fieldConfig]) => {
    if (fieldConfig.viewType === 'Picker') {
      if (data[fieldName]) {
        if (fieldConfig.multivalued) {
          if (data[fieldName].length) {
            pickerRelations = pickerRelations.concat(data[fieldName].map(uuid => ({ wtype: fieldConfig.contentWtype, uuid: uuid })));
          }
        } else {
          pickerRelations.push({ wtype: fieldConfig.contentWtype, uuid: data[fieldName] });
        }
      }
    }
  });

  const relationContentQueries = [];

  if (pickerRelations.length) {
    pickerRelations.forEach((relation, index) => {
      if (findContentByUuid(relation.uuid)) {
        return;
      }

      const pickerContentType = getContentTypeByConfigArg('wtype', relation.wtype, store.state.rawContentTypes);
      const pickerFields = filterFields(pickerContentType.fields, 'showInList', true).join(' ');

      relationContentQueries.push(`PICKER_NUMBER_${index}: ${pickerContentType.configs.single} (uuid:"${relation.uuid}") { uuid ${pickerFields} wtype }`);
    });
  }

  const project = store.state.environment.PROJECT;

  if (relationContentQueries.length) {
    const getPickersQuery = `query ${project}GetPickers { ${relationContentQueries.join(' ')} }`;
    const ApolloClient = resolveClient();

    try {
      selectedModule.value.loading = true;
      const result = await ApolloClient.query({ query: gql(getPickersQuery), fetchPolicy: 'no-cache', errorPolicy: 'ignore', notifyOnNetworkStatusChange: true });

      const resultObjects = Object.values(result.data).filter(picker => picker);

      if (resultObjects && resultObjects.length) {
        relationContents.value = relationContents.value.concat(resultObjects);
      }
    } catch (e) {
      console.log('[ERROR] ->', e);
    }
  }

  Object.entries(moduleFields).forEach(([fieldName, fieldConfig]) => {
    if (fieldConfig.viewType === 'Picker') {
      if (data[fieldName]) {
        if (fieldConfig.multivalued) {
          if (data[fieldName].length) {
            data[fieldName] = data[fieldName].map(uuid => findContentByUuid(uuid)).filter(prod => prod);
          }
        } else {
          data[fieldName] = findContentByUuid(data[fieldName]);
        }
      }
    }
  });

  // console.log('pickerRelations', pickerRelations, relationContentQueries, relationContents, data);
  if (cancelled) {
    throw { reason: 'cancelled' };
  }

  selectedModule.value.moduleName = moduleName;
  selectedModule.value.sectionID = sectionID;

  moduleContentType.value = {};
  moduleContentType.value.fields = moduleFields;

  moduleContent.value = { ...data };

  nextTick(() => {
    selectedModule.value.loading = false;
    selectedModule.value.active = true;
  });
};

// Email Preview
const previewEmailModal = ref(null);

const previewEmailByProduct = ref(false);

const showPreviewEmailByProductPackage = computed(() => store.state.environment.PROJECT === 'speedboat' && (props.content.wtype === 'email'));

const switchEmailPreview = () => {
  if (!previewEmailByProduct.value) {
    previewEmailModal.value.open();
    return;
  }

  sendInformation({ switchProductPreview: false });
  previewEmailByProduct.value = false;
};

// Receives information
const informationReceiver = async event => {
  // Case user unselected a section
  if (event.data.hasOwnProperty('unselectModule')) {
    selectedModule.value.active = false;
  }

  // Case save the pageconfig or close editMode of page builder
  if (event.data.hasOwnProperty(props.receiveInformationFlag)) {
    props.content[props.contentField] = JSON.stringify(event.data[props.receiveInformationFlag]);
  }

  // In case is page builder receive all information it needs
  if (event.data.hasOwnProperty('moduleFields')) {
    if (cancelToken.cancel) {
      cancelToken.cancel();
    }
    receiveModuleData(event.data.props, event.data.moduleFields, event.data.moduleName, event.data.sectionID, cancelToken);
  }

  // If received data types of ucpa.com when page builder is loaded
  if (event.data.hasOwnProperty('systemInformation')) {
    const systemInformation = { ...event.data.systemInformation };

    if (event.data.systemInformation.hasOwnProperty('dataTypes')) {
      Object.keys(event.data.systemInformation.dataTypes).forEach(key => {
        systemInformation.dataTypes[key].configs = { type: key };
      });
    }

    emit('update:systemInformation', event.data.systemInformation);
    console.log('[PIM] - Page buildersystem information', props.systemInformation);
  }

  // TODO: REMOVE AFTER CHANGE ALL WEBSITES WITH PAGE BUILDER
  if (event.data.hasOwnProperty('dataTypes')) {
    const systemInformation = { ...props.systemInformation };
    systemInformation.dataTypes = event.data.dataTypes;
    emit('update:systemInformation', systemInformation);
    console.log('[PIM] - Page buildersystem data types', systemInformation);
  }
};

// eslint-disable-next-line no-undef
defineExpose({ sendInformation });

window.addEventListener('message', informationReceiver, false);

onUnmounted(() => {
  window.removeEventListener('message', informationReceiver, false);
});
</script>
